export type CampaignType = 'like' | 'follow' | 'comment' | 'pagelike' | 'subscribe';
export type PlatformType = 'instagram' | 'facebook' | 'youtube' | 'threads';
export type PlatformAddType =
  | 'instagram'
  | 'facebook'
  | 'youtube'
  | 'threads'
  | 'nblog'
  | 'plus'
  | 'viewing';

export const SNS_PLATFORM = Object.freeze({
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  NBLOG: 'nblog',
  THREADS: 'threads',
  YOUTUBE: 'youtube',
});
export const TRANSLATE_PLATFORM = Object.freeze({
  facebook: '페이스북',
  instagram: '인스타그램',
  nblog: '네이버',
  threads: '스레드',
  youtube: '유튜브',
});

export const ACCOUNT_TYPE = Object.freeze({
  PLUS: 'plus',
  VIEWUP: 'viewup',
  VIEWUP_PLUS: 'viewupPlus',
});

export const SNS_BEHAVIOR_TYPE = Object.freeze({
  COMMENT: 'comment',
  FOLLOW: 'follow',
  LIKE: 'like',
  PAGELIKE: 'pagelike',
  SCRAP: 'scrap',
  SUBSCRIBE: 'subscribe',
});
export const TRANSLATE_SNS_BEHAVIOR_TYPE = Object.freeze({
  bookmark: '북마크',
  comment: '댓글',
  follow: '팔로우',
  like: '좋아요',
  notification: '알림',
  pagelike: '페이지좋아요',
  scrap: '스크랩',
  share: '배포',
  subscribe: '구독',
});

export const VIEWING_TYPE = Object.freeze({
  auto: '자동적립',
  click: '클릭뷰업',
  comment: '댓글뷰업',
  plus: '뷰플',
  post: '포스팅 뷰업',
});
